<div class="history-date">
  {{ item.date | date: "yyyy.MM.dd HH:mm" }}
</div>
<div class="history-description">{{ item.label }}</div>
<div
  class="history-amount"
  [class.negative]="item.amount?.startsWith('-')"
  [class.positive]="!item.amount?.startsWith('-')"
>
  {{ item.amount }}
</div>
<a
  routerLink="/user/cases"
  queryParamsHandling="merge"
  [queryParams]="item.filters"
>
  @if (item.filters) {
    <button
      payee-icon-button
      width="short"
    >
      <mat-icon>call_made</mat-icon>
    </button>
  }
</a>
